import { render, staticRenderFns } from "./prescription-manage-modal.vue?vue&type=template&id=2ad347fe&"
import script from "./prescription-manage-modal.vue?vue&type=script&lang=js&"
export * from "./prescription-manage-modal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports